var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',_vm._g(_vm._b({on:{"open":_vm.openHandler},scopedSlots:_vm._u([{key:"icon-calendar",fn:function(){return [_c('i',{staticClass:"ki ki-calendar"})]},proxy:true}])},'date-picker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }